/* eslint-disable no-new */
import { KeenSliderNavigation } from "./keen-slider-navigation-plugin";
import KeenSlider from "keen-slider";

/**
 * Initializes a publication slider on all elements with the `[js-publication-slider]` attribute.
 *
 */
export const buildPublicationSlider = () => {
  document.querySelectorAll("[js-publication-slider]").forEach((slider) => {
    new KeenSlider(slider, {}, [
      KeenSliderNavigation({
        arrows: false,
        dots: slider.querySelector("[data-dots]"),
      }),
    ]);
  });
};
